module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"smsLeft":"Messages left","smsQuotaExceeded":"Messages quota exceeded","changePlan":"Change plan"}}')
  delete Component.options._Ctor
}
